import { combineReducers } from '@reduxjs/toolkit'
import { apiUserDetailsSlice } from './slices/applications/ApiUserDetailsSlice/ApiUserDetailsSlice'
import { apiUsersSlice } from './slices/applications/ApiUsersSlice/ApiUsersSlice'
import { desktopSlice } from './slices/DesktopSlice/DesktopSlice'
import { userSlice } from './slices/UserSlice/UserSlice'
import { windowSlice } from './slices/WindowSlice/WindowSlice'

export const rootReducer = combineReducers({
  desktop: desktopSlice.reducer,
  window: windowSlice.reducer,
  user: userSlice.reducer,
  apiUsers: apiUsersSlice.reducer,
  apiUserDetails: apiUserDetailsSlice.reducer
})
